import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';
import {translate} from '../../plugins/i18n/i18n';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';

export default class Activity extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    target = undefined,
    // We also need to add the key how it is stored in the db (we use the db column names)
    no = undefined,
    designation = undefined,
  }) {
    super({
      id,
      number: number || no,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.target = target
      ? HitOnlineEnums.getEnumValue('ACTIVITY_TARGET', target, translate)
      : null;
    // For form items where we only store the designation in the data
    if (designation) {
      this.designation = designation;
    }
  }

  static get fkName() {
    return 'activity_id';
  }
  static get apiRoute() {
    return 'activity';
  }
  static get listPageRoute() {
    return 'activityList';
  }
  static get detailPageRoute() {
    return 'activityList';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return Activity.fkName;
  }
  get apiRoute() {
    return Activity.apiRoute;
  }
  get detailPageRoute() {
    return Activity.detailPageRoute;
  }
  get listPageRoute() {
    return Activity.listPageRoute;
  }
  static get config() {
    return {
      addable: false,
      duplicatable: false,
      importable: false,
      browsable: false,
      deletable: false,
    };
  }

  get config() {
    return Activity.config;
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'target',
    ];
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'target',
      'active',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'target',
    ]);
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE(),
      this.ACTIVE_ATTRIBUTE(),
      new AT.EnumerationAttribute({
        name: 'target',
        enumType: 'ACTIVITY_TARGET',
        enumClass: HitOnlineEnums,
        column: 'target',
        tableProperties: {
          header: 'hit-app.common.object',
          maxWidth: '0.5fr',
        },
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
